<template>
  <div
    class="zt-overlay top-0 bottom-0 left-0 right-0 fixed pointer-events-none justify-center items-center flex"
    :class="classes"
    :style="styles"
  >
    <div
      class="zt-overlay-dark-screen absolute top-0 bottom-0 left-0 right-0 bg-black w-full h-full "
      :style="reactiveOpacity"
    />
    <div v-if="isActive" class="relative">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ztOverlay',
  props: {
    opacity: {
      default: 0.5,
      type: [Number, String]
    },
    inner: {
      default: false,
      type: Boolean
    },
    active: {
      default: true,
      type: Boolean
    },
    zIndex: {
      default: 5,
      type: Number
    }
  },
  data() {
    return {
      stylesOverlay: {}
    }
  },
  computed: {
    isActive() {
      return this.active
    },
    reactiveOpacity() {
      return this.isActive ? { opacity: this.opacity } : { opacity: 0 }
    },
    classes() {
      return {
        'zt-overlay-inner': this.inner,
        'zt-overlay-active': this.isActive
      }
    },
    styles() {
      return {
        'z-index': this.zIndex
      }
    }
  }
}
</script>

<style
  scoped
  lang="css"
  src="../../../../styles/components/ztOverlay.css"
></style>
